import moment from "moment";
import {
  ENVIORNMENTS,
  getCurrentEnviornment,
  REACT_APP_AanlyticsURL,
  REACT_APP_AanlyticsURL_SANDBOX,
  REACT_APP_AanlyticsURL_web,
  REACT_APP_AanlyticsURL_web_SANDBOX,
} from "utils/constants";

export function persistUserEmail(email) {
  localStorage.setItem(`${getCurrentEnviornment()}_userEmail`, email);
  // localStorage.setItem("userEmail", email);
}

export function getLoggedInUserEmail() {
  return localStorage.getItem(`${getCurrentEnviornment()}_userEmail`);
}
export const getEmailAndVideoNameFromUrl = (url) => {
  // Split the URL by '/'
  const parts = url.split("/");
  // Get the email address (assuming it's the second-to-last part of the URL)
  const email = parts[parts.length - 2];
  // Get the last part of the URL
  const lastPart = parts[parts.length - 1];
  // Remove the ".mp4" extension if it exists
  const videoName = lastPart?.replace(".mp4", "");
  // Return an object containing the email and video name

  return generateVideoName(email, videoName);
};
export const generateVideoName = (userEmail, videoName) => {
  return `${userEmail}/${videoName}`;
};

export function generateUniqueId() {
  function s4() {
    return Math.round(Math.random() * 10000);
  }
  return s4() + "-" + s4() + "-" + s4() + "-" + s4();
}

export function base64toImage(imageData) {
  return `data:image/jpeg;base64,${imageData}`;
}

export function getFormattedDate(date) {
  return moment(date).format("DD/MM/YYYY");
}

export function adjustColumnHeightForIpad({ type, isLandscape, onCompare }) {
  if (isLandscape) {
    function getViewPortHeight(pixelsToMinus) {
      const pixelsToRemove = pixelsToMinus || "62px";
      return !onCompare
        ? `calc(54vh - ${pixelsToRemove})`
        : `calc(50vh - ${pixelsToRemove})`;
    }
    const innerHeight = window.innerHeight;
    const padWithTabsHeight = 917;
    const adjustedHeightWithTabs = window.innerHeight - 119 + "px !important";
    if (
      typeof type === "object" &&
      type?.current?.style &&
      innerHeight === padWithTabsHeight
    ) {
      type.current.style["min-height"] = getViewPortHeight();
      type.current.style.height = getViewPortHeight();
    }
    return function adjustHeightForIpad(node) {
      if (node && innerHeight === padWithTabsHeight) {
        type === "video"
          ? node.style.setProperty("height", getViewPortHeight(), "important")
          : node.style.setProperty("height", "97%", "important");
        window.scrollTo(0, 0);
      }
      if (
        node &&
        innerHeight !== padWithTabsHeight &&
        window.innerWidth <= 1366
      ) {
        type === "video"
          ? node.style.setProperty(
              "height",
              getViewPortHeight("52px"),
              "important",
            )
          : node.style.setProperty("height", "97%", "important");
        window.scrollTo(0, 0);
      }
    };
  } else {
    const innerHeight = window.innerHeight;
    const padWithTabsHeight = 917;
    const adjustedHeightWithTabs = window.innerHeight - 119 + "px !important";
    if (
      typeof type === "object" &&
      type?.current?.style &&
      innerHeight === padWithTabsHeight
    ) {
      type.current.style["min-height"] = adjustedHeightWithTabs;
      type.current.style.height = adjustedHeightWithTabs;
    }
    return function adjustHeightForIpad(node) {
      if (node && innerHeight === padWithTabsHeight) {
        type === "video"
          ? node.style.setProperty("height", "calc(100vh - 130px)", "important")
          : node.style.setProperty("height", "99%", "important");
        window.scrollTo(0, 0);
      }
    };
  }
}
export let VIDEO_HEIGHT = window.screen.availHeight;

export function getVideoRatio(height, grace = 0, isNumber = false) {
  if (height) {
    VIDEO_HEIGHT = height;
  }

  const heightLocal = height || VIDEO_HEIGHT;
  const finalWidth = Math.floor((heightLocal * 9) / 16) - grace;
  if (isNumber) {
    return finalWidth;
  }
  return finalWidth + "px";
}

export function getGraphHeight() {
  const graphHeight = getGraphContainerHeight() - 25;
  return Math.floor(graphHeight) + "px";
}

export function getGraphContainerHeight() {
  const { innerHeight } = window;
  const headerHeight = 68;
  const marginEtc = 42;
  const finalHeight = (innerHeight - headerHeight - marginEtc) / 4;
  return Math.floor(finalHeight);
}

export function getSearchedItem({ searchText, listOfObjects }) {
  if (Array.isArray(listOfObjects)) {
    return listOfObjects?.filter((item) =>
      Object.values(item).some((value) =>
        String(value)?.toLowerCase().includes(searchText),
      ),
    );
  }
}

export function getInitialLetters(username) {
  if (!username) return;
  return username
    ?.trim() // remove leading/trailing spaces
    .split(/\s+/) // split by one or more spaces
    .filter(Boolean) // remove empty entries (safety)
    .map((word) => word[0].toUpperCase()) // get first letter uppercase
    .join("");
}

export function getUniquesObjectsFromArray(arr) {
  if (!arr) return;
  return Array.from(new Map(arr?.map((obj) => [obj.userId, obj])).values());
}

export function isValidEmail(email) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
}

export function removeCurrentEmailFromLocalStorage() {
  localStorage.removeItem(`${getCurrentEnviornment()}_userEmail`);
}

export function getAnalyticsBaseUrl() {
  return getCurrentEnviornment() === ENVIORNMENTS.LIVE
    ? REACT_APP_AanlyticsURL
    : REACT_APP_AanlyticsURL_SANDBOX;
}
export function getAnalyticsBaseUrlM2C() {
  return getCurrentEnviornment() === ENVIORNMENTS.LIVE
    ? REACT_APP_AanlyticsURL_web
    : REACT_APP_AanlyticsURL_web_SANDBOX;
}
export function getDateAfterMonths(monthsToAdd) {
  const today = new Date();

  // Get target date by adding months
  const targetDate = new Date(today);
  targetDate.setMonth(today.getMonth() + monthsToAdd);

  // If original day is not in the new month (like 31st in Feb), adjust
  if (targetDate.getDate() !== today.getDate()) {
    targetDate.setDate(0); // sets to last day of previous month
  }

  return targetDate;
}

export function expiresInDays(EndDate) {
  if (!EndDate) return;

  const currentDate = new Date();

  const endDate = new Date(EndDate);

  // Calculate the difference in time (in milliseconds)
  const timeDifference = endDate - currentDate;

  // Convert the difference from milliseconds to days
  const dayDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

  return dayDifference;
}

export function getVideoHeight({
  width,
  height,
  videoWidth,
  videoHeight,
  grace = 0,
  isNumber = false,
}) {
  const finalHeight = Math.floor((width * videoHeight) / videoWidth);

  if (finalHeight < 300) {
    return "300px";
  }

  return finalHeight > height ? height - 100 + "px" : `${finalHeight}px`;
}

export async function decompressGzipBase64(base64Data) {
  // Remove accidental whitespace/newlines
  const base64 = base64Data.replace(/\s/g, "");

  // Base64 -> binary
  const binary = atob(base64);

  // Binary -> Uint8Array
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));

  // GZIP -> decompressed bytes
  const stream = new Blob([bytes])
    .stream()
    .pipeThrough(new DecompressionStream("gzip"));

  const decompressed = await new Response(stream).arrayBuffer();

  // Bytes -> UTF-8 string
  const text = new TextDecoder("utf-8").decode(decompressed);

  console.log("Decompressed data:", JSON.parse(text));

  // JSON -> JavaScript object
  return { Graph_Data: JSON.parse(text) };
}

export function getFilterArrOnSearch({ searchableFields, data, searchValue }) {
  const filtered = data?.filter((item) =>
    searchableFields.some((field) =>
      item?.[field]
        ?.toString()
        ?.toLowerCase()
        .includes(searchValue?.toLowerCase()),
    ),
  );
  return filtered;
}
